module.exports = __webpack_public_path__ + "img/icn-phone.87aa2065.svg";